const en = {
    lang_person_center: "Profile",
    lang_log_out: "Logout",
    lang_controlCenter: "Control Center",
    lang_communal_card: "Public Card",
    lang_my_memberwork: "My Card",
    lang_account_info: "My Info",
    lang_my_hobbies: "My Interests",
    lang_my_agent: "My Agent",
    lang_return: "Back",
    lang_request_error: "Network Error",
    lang_user_error: "Account Error",
    lang_login_in: "Login",
    lang_all: "All",
    lang_applying: "Applying",
    lang_stop_agent: "Stop Agent",
    lang_passed: "Approved",
    lang_month_bill: "Monthly Bill",
    lang_introduction: "A Cross-Regional Product Exhibition Center",
    lang_news: "News",
    lang_becomestore: "Create Store",
    lan_line_me: "Contact Us",
    lan_common_problem: "FAQ",
    lan_feedback: "Feedback",
    lan_privacy_agreement: "Privacy Policy",
    lan_shopping_terms_of_service: "Shopping Terms",
    lan_agency_terms: "Agent Terms",
    lang_about: "About",
    lang_working_hours: "Working Hours",
    lang_hotline: "Hotline",
    lang_take_down: "Removed",
    lang_cancel_agent: "Cancel Agent",
    lang_cancel_agent_success: "Agent Cancelled",
    lang_memberwork_collection: "Card Collection",
    lang_collection_memberwork: "Collect Card",
    lang_memberwork_agent: "Apply Card",
    lang_memberwork_collection_btn: "Card Collection Request",
    lang_add_memberwork: "Add Card",
    lang_edit_memberwork: "Edit Card",
    lang_delete_memberwork: "Delete Card",
    lang_open_chat: "Open Chat",
    lang_link: "Link",
    lang_sending_method: "Send Method",
    lang_memberwork_info: "Card Info",
    lang_operate: "Action",
    lang_enter_complete: "Please Complete",
    lang_modify_success: "Updated",
    lang_delete_success: "Deleted",
    lang_delete_confirm: "Confirm Delete?",
    lang_not_disclose_card: "Hide Card?",
    lang_open_disclose_card: "Show Card?",
    lang_not_disclose_phone_card: "Hide Phone?",
    lang_open_disclose_phone_card: "Show Phone?",
    lang_memberwork_delete_last_error: "Cannot Delete Last Card",
    lang_memberwork_delete_new_error: "Cannot Delete Newest Card",
    lang_open_personal_chat: "Chat",
    lang_forward: "Forward",
    lang_delete: "Delete",
    lang_revoke: "Revoke",
    lang_product_basic_information: "Product Info",
    lang_product_category: "Category",
    lang_product_description: "Description",
    lang_personal_retail: "Retail",
    lang_commercial_trade: "Trade",
    lang_serve: "Service",
    lang_preview: "Preview",
    lang_save: "Save",
    lang_confirm_release: "Confirm Release?",
    lang_release_success: "Released",
    lang_confirm_save: "Confirm Save?",
    lang_save_success: "Saved",
    lang_save_failed: "Save Failed",
    lang_date: "Date",
    lang_date_select: "Select Date",
    lang_print: "Print",
    lang_month_total_bill: "Monthly Commission",
    lang_merchant: "Merchant",
    lang_merchant_info: "Merchant Info",
    lang_commission: "Commission",
    lang_password_inconsistent: "Passwords Mismatch",
    lang_read_agree: "I Agree to",
    lang_Terms_Policy: "Terms & Policy",
    lang_register: "Register",
    lang_forget_password: "Forgot Password",
    lang_back: "Back",
    lang_next: "Next",
    lang_Submit_Pay: "Submit & Pay",
    lang_repeated_email: "Email Exists",
    lang_error_format_email: "Invalid Email",
    lang_account_password_error: "Invalid Credentials",
    lang_email_not_exist: "Email Not Registered",
    lang_index: "Home",
    lang_agent_delete_warning: "Delete Agent?",
    lang_cancel_agent_warning: "Cancel Agent?",
    lang_release: "Release",
    lang_start_chat: "Start Chat",
    lang_modify_information: "Edit Info",
    lang_email: "Email",
    lang_login_email: "Login Email",
    lang_name: "Name",
    lang_address: "Address",
    lang_mobile: "Mobile",
    lang_mobile_number: "Phone",
    lang_password: "Password",
    lang_provide_service_type: "Service Type",
    lang_none: "None",
    lang_education_time: "Education Time",
    lang_education_location: "Education Location",
    lang_academic_and_content: "Education",
    lang_location_academic_and_content: "Education Location",
    lang_certificate: "Certificate",
    lang_add: "Add",
    lang_basic_information: "Basic Info",
    lang_educational_information: "Education Info",
    lang_memberwork_holder: "Card Holder",
    lang_welcome_you: "Welcome",
    lang_shopopee_person: "Retail",
    lang_shopopee_service: "Service",
    lang_shopopee_trade: "Trade",
    lang_new_platform: "New Platform",
    lang_unlimited_release: "Unlimited Releases",
    lang_build_your_store: "Build Your Store",
    lang_your_store: "My Store",
    lang_from_different_web: "From Different Servers",
    lang_contact: "Contact",
    lang_support_different: "Multi-Device Support",
    lang_quickly_search: "Quick Search",
    lang_connect_different: "Connect Merchants",
    lang_improve_business: "Enhance Business",
    lang_sign_up: "Sign Up",
    lang_24_hours: "24/7",
    lang_24_hours_operation: "24/7 Operation",
    lang_various_payment_method: "Payment Methods",
    lang_credit_card: "Credit Card",
    lang_multiple_member_discount: "Member Discounts",
    lang_member_discount_by_level_setting: "Set Discounts",
    lang_erp_sup: "ERP Support",
    lang_perfect_integration: "System Integration",
    lang_distributed_data_design: "Distributed Data",
    lang_newest: "Latest",
    lang_bargain_recommendation: "Recommendations",
    lang_latest_product: "New Products",
    lang_recommend_for_you: "For You",
    lang_feedback: "Feedback",
    lang_feedback_info_error: "Fill Feedback",
    lang_recommended_bamboo_shoots: "Recommended",
    lang_latest_product_recommendation: "New Products",
    lang_no_goods: "No Products",
    lang_success_agent: "Applied",
    lang_repeat_agent: "Already Applied",
    lang_request_agent: "Apply",
    lang_success_include: "Added",
    lang_success_Wait_pass_include: "Pending",
    lang_success_include_to_cards: "Added to Cards",
    lang_repeat_include: "Already Added",
    lang_view_business_cards: "View Cards",
    lang_prompt: "Prompt",
    lang_will_take: "Redirecting to",
    lang_website: "Website",
    lang_my_promotion: "My Promotions",
    lang_reset_alert: "Check Email",
    lang_sure: "Confirm",
    lang_live_promotion: "Live Promo",
    lang_product_promotion: "Product Promo",
    lang_add_promotion: "Add Promo",
    lang_under_review: "Reviewing",
    lang_approved: "Approved",
    lang_approval_failed: "Rejected",
    lang_approval_cancel: "Cancel Review",
    lang_state: "Status",
    lang_company: "Company",
    lang_link_company: "Contact Company",
    lang_company_name: "Company Name",
    lang_title: "Title",
    lang_promotion_date: "Promo Date",
    lang_live_time: "Live Time",
    lang_live_link: "Live Link",
    lang_content: "Content",
    lang_modify: "Edit",
    lang_update_img_note: "Upload Image",
    lang_update_qrcode: "Upload QR Code",
    lang_choose_img: "Choose Image",
    lang_mr: "Mr.",
    lang_miss: "Ms.",
    lang_mrs: "Mrs.",
    lang_appellation: "Title",
    lang_memberwork: "Card",
    lang_memberwork_whatsApp: "WhatsApp Card",
    lang_online_memberwork: "Chat Card",
    lang_pass_add: "Approve & Add",
    lang_edit_information: "Edit Info",
    lang_hint_not_whatsapp: "No Phone",
    lang_copy: "Copy",
    lang_paste: "Paste",
    lang_clear: "Clear",
    lang_backgroud_color: "Background Color",
    lang_choose_background_img: "Choose Background",
    lang_choose_template: "Choose Template",
    lang_select_special_effects: "Select Effect",
    lang_choose_share_background_img: "Choose Background",
    lang_working_hours_alert: "Leave Blank for Current",
    lang_company_logo: "Logo",
    lang_company_name_eng: "Company Name (EN)",
    lang_company_address: "Address",
    lang_company_address_eng: "Address (EN)",
    lang_company_telphone: "Phone",
    lang_company_telphone_2: "Phone 2",
    lang_company_email: "Email",
    lang_my_email: "My Email",
    lang_your_name: "Your Name",
    lang_your_name_eng: "Your Name (EN)",
    lang_company_fax: "Fax",
    lang_position_company: "Position",
    lang_telephone: "Phone",
    lang_your_profile: "Profile",
    lang_company_introduction_link: "Company Link",
    lang_product_introduction_link: "Product Link",
    lang_self_introduction_link: "Profile Link",
    lang_jumpto: "Jump",
    lang_close: "Close",
    lang_goto: "Go",
    lang_text: "Text",
    lang_position: "Position",
    lang_name_eng: "Name (EN)",
    lang_self_introduction: "Profile",
    lang_drag: "Drag",
    lang_setting: "Settings",
    lang_clear_confirm: "Confirm Clear?",
    lang_selling_price: "Price",
    lang_product_information: "Product Info",
    lang_product_name_hk: "Product Name (CN)",
    lang_product_name_en: "Product Name (EN)",
    lang_product_description_hk: "Description (CN)",
    lang_product_description_en: "Description (EN)",
    lang_fillComplete: "Complete",
    lang_product_cost: "Price: HKD",
    lang_product_purchaseCost: "Cost: HKD",
    lang_product_gross_weight: "Weight: kg",
    lang_product_unit: "Unit",
    lang_add_product: "Add Product",
    lang_sales_volume: "Sales",
    lang_commission_payable: "Commission",
    lang_unpaid: "Unpaid",
    lang_personal: "Personal",
    lang_link_personal: "Contact",
    lang_personal_chat: "Chat",
    lang_product_chat: "Product Chat",
    lang_service_chat: "Service Chat",
    lang_information_chat: "Info Chat",
    lang_open: "Open",
    lang_open_success: "Chat Opened",
    lang_please_select_user: "Select User",
    lang_chat_room_name: "Chat Room",
    lang_please_input_room: "Enter Room Name",
    lang_service_request: "Service Request",
    lang_service_type_selection: "Service Type",
    lang_information_content: "Info",
    lang_choose_service_provider: "Select Provider",
    lang_all_businesses: "All Businesses",
    lang_select_top: "Top",
    lang_published_success: "Published",
    lang_published_failed: "Publish Failed",
    lang_send: "Send",
    lang_please_service_category: "Select Category",
    lang_not_found_provider: "No Provider",
    lang_select_provider: "Select Provider",
    lang_input_information: "Enter Info",
    lang_please_login_in: "Login",
    lang_input_error: "Enter Keyword",
    lang_search_result: "Search Results",
    lang_my_interests: "My Interests",
    lang_select_person_type: "Select Retail Type",
    lang_select_trade_type: "Select Trade Type",
    lang_commodity_platform: "Product Platform",
    lang_service_platform: "Service Platform",
    lang_agent: "Agent",
    lang_sale: "Sale",
    lang_buyer_login: "Buyer Email",
    lang_buyer_name: "Buyer Name",
    lang_send_success: "Sent",
    lang_not_active_alert: "Account Not Active",
    lang_resend_code_hint_not: "Did not receive the email?",
    lang_resend_code: "Resend",
    lang_product_name: "Product Name",
    lang_related_products: "Related Products",
    lang_products: "Products",
    lang_sales_area: "Sales Area",
    lang_agency_area: "Agent Area",
    lang_font_select: "Font",
    lang_font_size: "Font Size",
    lang_font_color: "Font Color",
    lang_font_bold: "Bold",
    lang_width: "Width",
    lang_height: "Height",
    lang_please_choose_enter: "Select",
    lang_expression: "Emoji",
    lang_share_content: "Share",
    lang_input_share_email_address: "Enter Email",
    lang_share_success: "Shared",
    lang_upload: "Upload",
    lang_upload_success: "Uploaded",
    lang_agent_request: "Apply Agent",
    lang_go_shop_href: "Leaving Shopopee",
    lang_login: "Login",
    lang_forget_password_text: "Forgot Password",
    lang_approval_failed_text: "Rejected",
    lang_please_select_type: "Select Type",
    lang_not_bind_3d_shop: "No 3D Shop",
    lang_release_approval: "Submitted",
    lang_save_approval: "Saved",
    lang_feedback_submitted_successfully: "Feedback Sent",
    lang_details: "Details",
    lang_select_agent: "Select Agent",
    lang_loaded_end: "End",
    lang_load_more: "Load More",
    lang_curr_memberwork: "Current Card",
    lang_add_new_memberwork_confirm: "Add New Card?",
    lang_copy_success: "Copied",
    lang_order_unpaid: "Unpaid Order",
    lang_user_not_found: "User Not Found",
    lang_my_order: "My Orders",
    lang_my_hall_order: "My Hall Orders",
    lang_completed: "Completed",
    lang_edu_input_alert: "Complete Education Info",
    lang_commission_total: "Total Commission",
    lang_null: "Empty",
    lang_personal_link: "Personal Link",
    lang_upload_custom: "Upload Custom",
    lang_null_alert: "Empty",
    lang_setting_default_memberwork: "Set Default Card",
    lang_setting_default_memberwork_alert: "Set Default Card?",
    lang_cancel: "Cancel",
    lang_invalid_item_alert: "Invalid Link",
    lang_order_no: "Order No.",
    lang_contact_way: "Contact",
    lang_date_order: "Order Date",
    lang_is_agree: "Agree to Terms",
    lang_go_eshopopee_confirm: "Leaving Shopopee",
    lang_memberwork_record: "Record",
    lang_hyperlink: "Link",
    lang_memberwork_record_for_edit: "Edit Record",
    lang_memberwork_record_log: "Record Log",
    lang_edit_share_line: "Edit Link",
    lang_edit_share_QRCode: "Upload QR Code",
    lang_wrok_show_commpany_tpye: "Company Card",
    lang_wrok_show_personal_tpye: "Personal Card",
    lang_time: "Time",
    lang_img: "Image",
    lang_QRCode: "QR Code",
    lang_personal_introduction: "Profile",
    lang_company_profile: "Company Profile",
    lang_shopopee_card: "Card",
    lang_select_local_img: "Select Image",
    lang_new_join: "New",
    lang_please_select_product: "Select Product",
    lang_novice_guide: "Guide",
    lang_video_introduction: "Video",
    lang_input_password: "Enter Password",
    lang_reset_password_success: "Password Reset",
    lang_modification_password: "Change Password",
    lang_new_password: "New Password",
    lang_confirm_password: "Confirm Password",
    lang_new_user_guide: "User Guide",
    lang_card_layout_setting_hint: "Card Layout",
    lang_card_layout_setting: "Card Settings",
    lang_merchant_operation_guide: "Merchant Guide",
    lang_your_email: "Your Email",
    lang_account_email: "Account Email",
    lang_free_registration: "Free Sign Up",
    lang_free_registration_now: "Sign Up Now",
    lang_custom_edit: "Custom Edit",
    lang_upload_bg_img: "Upload Background",
    lang_head_portrait: "Profile Photo",
    lang_skip_save: "Skip & Save",
    lang_skip: "Skip",
    lang_copied_clipboard: "Copied",
    lang_related_goods: "Related Products",
    lang_message: "Message",
    lang_sys_message: "System Message",
    lang_memberwork_list: "Card List",
    lang_my: "My",
    lang_language_setting: "Language",
    lang_company_register: "Company Sign Up",
    lang_company_website: "Website",
    lang_company_info: "Company Info",
    lang_submit: "Submit",
    lang_required: "Required",
    lang_chat_server_error: "Chat Server Error",

    lang_authenticate_expiration: "Auth Expired",
    lang_company_not_exist: "Company Not Found",
    lang_not_exist: "Not Found",
    lang_certified: "Certified",
    lang_cancel_certifie: "Uncertify",
    lang_certifie: "Certify",
    lang_not_certified: "Uncertified",
    lang_under_certification: "Certifying",
    lang_expired: "Expired",
    lang_not_active: "Inactive",
    lang_not_fill: "Unfilled",
    lang_add_user: "Add User",
    lang_edit_company_card_template: "Edit Company Card Template",
    lang_company_template_save_confirm: "Editing the template will update all employee cards. This may take time. Confirm?",
    lang_company_info_save_confirm: "Editing company info will update all employee cards. This may take time. Confirm?",
    lang_user: "User",
    lang_log_off: "Log Off",
    lang_department_limit_warning: "Department limit reached. Upgrade to add more.",
    lang_delete_department_warning: "Cannot delete, department has employees.",
    lang_input_department_name: "Enter Department Name",
    lang_input_position_name: "Enter Position Name",
    lang_department_name: "Department Name",
    lang_position_name: "Position Name",
    lang_member_info: "User Info",
    lang_admin_user: "Admin",
    lang_edit_staff_confirm: "Editing user info will update their card. This may take time. Confirm?",
    lang_frist_default_memberwork_alert: "Welcome to Shopopee! Your company card has been generated. You can edit the template later.",
    lang_staff_frist_default_memberwork_alert: "Welcome to Shopopee! Your company card has been generated using the template.",
    lang_cancel_last_admin_alert: "Cannot delete the last admin.",
    lang_unable_to_chat_with_oneself: "Cannot chat with yourself.",
    lang_your_memberwork: "Your Card",
    lang_apply_certification: "Apply Certification",
    lang_company_auth: "Company Auth",
    lang_apply_list: "Auth Records",
    lang_apply_information: "Record Info",
    lang_modify_company_info: "Edit Company Info",
    lang_personal_info: "Personal Info",
    lang_company_memberwork: "Company Card",
    lang_logooff_confirm_1: "You are about to log off. Confirm?",
    lang_logooff_confirm_2: "Logging off will permanently delete your account. Confirm?",
    lang_logoff_success: "Logoff Success",
    lang_company_code: "Company Code",
    lang_optional_information: "Optional Info",
    lang_default_password_label: "Default password if left blank:",
    lang_become_company: "Become Company User",
    lang_become_company_confirm_1: "Becoming a company user enables management features but requires resetting your card. Confirm?",
    lang_become_company_confirm_2: "You are about to become a company user. You will need to log in again. Confirm?",
    lang_edit_item: "Edit Item",
    lang_more_info: "More Info",
    lang_retract: "Collapse",
    lang_company_message: "Company Message",
    lang_employee_message: "Employee Message",
    lang_clear_success: "Clear Success",
    lang_hint_download: "Please download the Shopopee App.",
    lang_clear_fail: "Clear Failed",
    lang_view_staff_message: "View Employee Message",
    lang_log_off_login: "Your company is logged off. Reactivate?",
    lang_log_off_self_alert_1: "Confirm to log off?",
    lang_log_off_self_alert_2: "You are logging off. Confirm?",
    lang_all_empty: "No Records",
    lang_message_settings: "Message Settings",
    lang_cache_clear: "Clear Cache",
    lang_about_us: "About Us",
    lang_version_info: "Version Info",
    lang_log_out_2: "Log Out",
    lang_notification_bar: "Notification Bar",
    lang_vibration: "Vibration",
    lang_bell: "Ringtone",
    lang_select_card_animation: "Select Animation",
    lang_download: "Download",
    lang_auth_your_email: "Verify Email",
    lang_select: "Select",
    lang_select_card: "Select Card",
    lang_staff_limit_warning: "Employee limit reached. Upgrade to add more.",
    lang_logoff_company: "Logoff Company",
    lang_logoff_company_confirm: "Logging off will delete all company data. Confirm?",
    lang_logoff_company_confirm_2: "Confirm to log off? You can reactivate within 24 hours.",
    lang_company_logoff_login_alert: "Your company admin is logging off. Cannot log in.",
    lang_include_card: "Included Cards",
    lang_chat_message: "Chat Messages",
    lang_CAPTCHA: "CAPTCHA",
    lang_please_email: "Enter Email",
    lang_send_vcode_alert: "Check your email for the code.",
    lang_vcode_error: "Code Error",
    lang_bill: "My Bill",
    lang_use_app_browser: "Please use a mobile browser to download.",
    lang_download_hint_android: "Requires Android 7.1 or later.",
    lang_download_hint_ios: "Requires iOS 15.0 or later.",
    lang_select_target_member: "Select Target User",
    lang_select_target_member_hint: "All cards and chat records will be transferred to the selected user.",
    lang_select_one_target_member_hint: "Cards and chat records will be transferred to the selected user.",
    lang_mobile_company_number: "Mobile Number",
    lang_buy: "Buy",
    lang_submit_apply: "Submit Application",
    lang_element: "Element",
    lang_bill_id: "Bill ID",
    lang_bill_order_type: "Bill Type",
    lang_bill_email: "Orderer Email",
    lang_bill_username: "Orderer Name",
    lang_bill_tel: "Orderer Phone",
    lang_bill_total: "Total Amount",
    lang_pay_no: "Payment ID",
    lang_pay_state: "Payment Status",
    lang_pay_date: "Payment Date",
    lang_pay_method: "Payment Method",
    lang_bill_state: "Order Status",
    lang_order_date: "Order Date",
    lang_verify_date: "Approval Date",
    lang_resubmit: "Resubmit",
    lang_paid: "Paid",
    lang_refused: "Refused",
    lang_company_auth_apply: "Company Auth Application",
    lang_business_paper: "Business License",
    lang_span_selected_play_hint: "Selected HKD$",
    lang_click: "Click",
    lang_communication_method: "Contact Method",
    lang_show: "Show",
    lang_hide: "Hide",
    lang_show_hide: "Show/Hide",
    lang_hint_is_animate_null: "Enter custom animation.",
    lang_not_share_not_open: "Member settings are private. Sharing is disabled.",
    lang_show_share_greetings: "Share Greeting",
    lang_set_watsapp: "Set WhatsApp",
    lang_upload_paper_notice_1: "Upload business license.",
    lang_format: "Format",
    lang_upload_paper_notice_2: "After uploading, pay the fee via PayPal.",
    lang_upload_paper_notice_3: "Click Submit & Pay.",
    lang_upload_paper_notice_4: "Drag image files here.",
    lang_upload_paper_notice_5: "Click to select image.",
    lang_note: "Note",
    lang_upload_paper_notice_6: "If already uploaded, click Submit & Pay.",
    lang_upload_paper: "Upload License",
    lang_add_staff_limit: "Increase Employee Limit",
    lang_transfer: "Transfer",
    lang_transfer_all: "Transfer All",
    lang_select_card_type: "Select Card Type",
    lang_please_input_vcode: "Enter Verification Code",
    lang_input_vcode_note: "Your activation code has been sent to your email.",
    lang_select_card_type_note: "Select your category to display your card.",
    lang_why_auth_title: "Why Authenticate?",
    lang_why_auth_alert: "Authentication ensures your company's authenticity on Shopopee.",
    lang_why_auth_alert2: "Authentication boosts your company's credibility.",
    lang_why_auth_alert3: "Authentication retains chat records for 1 year.",
    lang_return_from_eshopopee: "Return to e-Shopopee?",
    lang_invite: "Invite",
    lang_default_password_alert: "Set login password.",
    lang_connect_chat_server_failed: "Failed to connect to chat server.",
    lang_recommend_person_sales: "Sales Referral",
    lang_recommend_trade_sales: "Trade Referral",
    lang_recommend_service_sales: "Service Referral",
    lang_open_e_shopop_hint: "Apply for e-Shopopee: Get a 3D store, website, and management system for 30 days. Proceed?",
    lang_no_cards: "No Cards",
    lang_anonymous_user: "Anonymous User",
    lang_user_exception: "User Account Exception",
    lang_chat_update_file_failed: "File Upload Failed",
    lang_temporary: "Temporary",
    lang_please_input_videos_input: "Enter Video Link",
    lang_error_time_num: "Enter valid time.",
    lang_robot_setting: "Bot Settings",
    lang_welcome_message: "Welcome Message",
    lang_auto_reply_switch_text: "Enable Auto Reply?",
    lang_animation_type: "Animation Type",
    lang_video_link_input: "Video Link",
    lang_flat_scrolling: "Flat Scroll",
    lang_descriptive_text: "Description",
    lang_animation_playback_time: "Animation Playback Time",
    lang_video_cover: "Video Cover",
    lang_update_img_card_addinfo6_hint: "Upload 400*250 image. Defaults to YouTube cover if not uploaded.",
    lang_3d_scrolling: "3D Scroll",
    lang_connect_chat_sever_error_405: "Failed to connect to chat server. Error 405.",
    lang_anonymous: "Anonymous",
    lang_business_currently_no_product_message: "Sorry, no products available.",
    lang_empty_roomname_error: "Group name cannot be empty.",
    lang_confirm_remove_chat_user: "Confirm to remove this member?",
    lang_dissolve_group: "Dissolve Group",
    lang_dissolve_group_confirm1: "Confirm to dissolve group?",
    lang_dissolve_group_confirm2: "You are dissolving this group. This cannot be undone. Confirm?",
    lang_dissolve_success: "Group Dissolved",
    lang_return_chat: "Back to Chat",
    lang_chat_room: "Chat Group",
    lang_create_multiple_group: "Create Group Chat",
    lang_select_user: "Select User",
    lang_invite_success: "Invite Success",
    lang_input_groupname_please: "Enter Group Name",
    lang_click_to_view: "Click to View",
    lang_auto_welcome_message: "Welcome! Assistant Chris is here to help.",
    lang_group_name: "Group Name",
    lang_group_avatar: "Group Avatar",
    lang_group_members: "Group Members",
    lang_share_chat_group: "Share Group",
    lang_join_chat_group: "Join Group",
    lang_join_chat_success: "Join Success",
    lang_join_chat_alert: "You have already joined this group.",
    lang_expiration: "Validity",
    lang_titles: "Title",
    lang_date_error_1: "Invalid Date",
    lang_submit_chat_join_success: "Submitted for admin approval.",
    lang_apply_join: "Apply to Join",
    lang_join_success: "Join Success",
    lang_sure_pass_apply: "Confirm to approve application?",
    lang_creator: "Creator",
    lang_default_user_info_alert: "Set profile info.",
    lang_toggle_to_person_user: "Switch to Personal User",
    lang_toggle_to_company_user: "Switch to Company User",
    lang_toggle_user_confirm: "Switching will hide company info. You can switch back later. Confirm?",
    lang_toggle_company_confirm: "Switching may require re-entering company info. You can switch back later. Confirm?",
    lang_toggle_success_pls: "Switch success. Please log in again.",
    lang_my_product: "My Products",
    lang_manage_product: "Manage Products",
    lang_product_list: "Product List",
    lang_confirm_go_backstage: "Redirect to merchant backend. Confirm?",
    lang_title_backstage: "Vendor Backend",
    lang_file_document_center: "File Center",
    lang_file_oversize: "File size cannot exceed 50MB.",
    lang_file_type_error_1: "Unsupported file format.",
    lang_select_worktype_pls: "Select Card Type",
    lang_file_not_found_1: "File deleted.",
    lang_now_downloading: "Downloading...",
    lang_product_link: "Product Link",
    lang_product_img: "Product Image",
    lang_card_product_1: "Card Product",
    lang_select_card_product_1: "Select Card Product",
    lang_Easy_registration: "Quick Registration",
    lang_Advanced_registration: "Advanced Registration",
    lang_person_registration: "Personal Registration",
    lang_select_card_template_please: "Select Card Template",
    lang_select_memberwork_template_confirm: "Confirm to use this template?",
    lang_upload_product_confirm_1: "Upload product?",
    lang_sure_restart_guide_confirm: "Confirm to start quick guide?",
    lang_product_sale_website: "Product Promotion Site",
    lang_pay_setting: "Payment Settings",
    lang_add_paymethod_text: "Add Payment Method",
    lang_paymethod_list: "Payment Methods",
    lang_main_name_text: "Primary Language Name",
    lang_paralanguage_name: "Secondary Language Name",
    lang_notes: "Notes",
    lang_paymentmethod: "Payment Method",
    lang_revice_account: "Receiving Account",
    lang_commission_text: "Fee",
    lang_percent_text: "Percentage",
    lang_in_the_store: "View in Store",
    lang_commission_per: "Fee (%)",
    lang_dispatch: "Dispatch",
    lang_sure_dispatch: "Confirm to dispatch?",
    lang_login_success: "Login Success",
    lang_set_admin: "Set as Admin",
    lang_unset_admin: "Remove Admin",
    lang_set_admin_confirm: "Confirm to set as admin?",
    lang_unset_admin_confirm: "Confirm to remove admin?",
    lang_operate_success: "Operation Success",
    lang_dispatch_success: "Dispatch Success",
    lang_complete_receipt_confirm: "Confirm to complete receipt?",
    lang_already_select_receipt: "Receipt reply selected.",
    lang_already_cancel_receipt: "Receipt reply canceled.",
    lang_input_order_no_please: "Enter Order No.",
    lang_order_no_repeat: "Order No. Duplicated",
    lang_receipt_no_span: "Receipt No.",
    lang_send_group_notice_msg: "Send Group Notice",
    lang_input_group_notice_pls: "Enter Group Notice",
    lang_send_success_text_1: "Sent",
    lang_prohibition: "Mute",
    lang_prohibiting: "Muted",
    lang_input_pls_text: "Enter",
    lang_remove_member_text: "Remove Member",
    lang_cancel_select_receipt: "Cancel Receipt Selection",
    lang_in_progress: "In Progress",
    lang_exhibition_not_currently: "Recruiting",
    lang_worktype_num_limit: "Max 3 categories.",
    lang_change_style_text: "Change Style",
    lang_share_card: "Share Card",
    lang_Promotion_text_1: "Promotion",
    lang_select_company_type: "Select Company Type",
    lang_company_card_animation: "Company Card Animation",
    lang_collection_btn: "Collection Request",
    lang_invite_user_text: "Invite User",
    lang_add_limit_num: "Increase Limit",
    lang_cancel_admin: "Remove Admin",
    lang_set_admin_text: "Set Admin",
    lang_shopopee_person_text: "Personal Retail",
    lang_shopopee_service_text: "Service",
    lang_shopopee_trade_text: "Trade",
    lang_Address_book: "Contacts",
    lang_query_card_text: "Search Card",
    lang_shop_text_1: "Store",
    lang_my_3D_shop: "3D Store",
    lang_apply_change: "Request Exchange",

    lang_related_card_not_found: "No related cards found",
    lang_add_address_book: "Add address book",
    lang_email_or_tel_repeat: "Email or phone number repeated",
    lang_user_repeat: "User already exists",
    lang_send_addinfo9_error_1: "Please do not repeat invitations",
    lang_Quick_guidance: "Quick guidance",
    lang_search_add_card: "Search to add card",
    lang_enter_address_book: "Enter address book",
    lang_invite_to_shopopee: "Invite to Shopopee",
    lang_scan: "Scan",
    lang_import_to_address_book: "Import to address book",
    lang_department: "Department",
    lang_create_group: "Create group",
    lang_group_type: "Group type",
    lang_files_text: "Files",
    lang_send_sms_confirm: "No email added, send via SMS?",
    lang_email_none_text: "No email added",
    lang_read_address_book_error: "Failed to read address book",
    lang_company_user_limit: "Current user limit is",
    lang_person: "Person",
    lang_curr_version_not_sup: "Current version not supported",
    lang_card_info: "Card info",
    lang_add_admin: "Add admin",
    lang_group_notice: "Group notice",
    lang_Remove_group_members: "Remove group members",
    lang_remove_operation: "Remove",
    lang_select_member_pls: "Please select member",
    lang_connot_remove_last_admin: "Cannot remove the last admin",
    lang_remove_member_confirm: "Confirm to remove member?",
    lang_select_pls: "Please select",
    lang_card_animation: "Card animation",
    lang_order_item: "Order item",
    lang_d_address: "Delivery address",
    lang_d_cost: "Shipping cost",
    lang_total_text: "Total",
    lang_shopcart: "Shopping cart",
    lang_ask_text: "Inquiry",
    lang_ask_item_alert_1: "Cannot inquire about own product",
    lang_submit_order_1: "Submit order",
    lang_subtotal_1: "Subtotal",
    lang_transport: "Transport",
    lang_transport_method: "Shipping method",
    lang_international_address: "International address",
    lang_area_text: "Area",
    lang_transport_cost: "Shipping cost",
    lang_pay_commission: "Pay commission",
    lang_total_price: "Total price",
    lang_pay_text_1: "Payment",
    lang_none_order_item_alert: "No items in the order",
    lang_select_transport_alert: "Please select shipping method",
    lang_select_international_alert: "Please select international address",
    lang_select_address_alert: "Please enter address",
    lang_select_payment_alert: "Please select payment method",
    lang_payment_order_confirm: "Payment successful, view order?",
    lang_cart_none_item_alert: "No items in the cart",
    lang_cart_item_num_limit_alert: "Cart item quantity limit reached",
    lang_already_add_cart_alert: "Already added to cart",
    lang_jump_to_view: "Click to view",
    lang_pull_confirm_text_1: "Confirm to pull this item off?",
    lang_pull_success: "Successfully pulled off",
    lang_lose_item_alert: "Removed invalid items from order",
    lang_order_confirm_text: "Order confirmation",
    lang_item_info_1: "Product info",
    lang_price_text: "Price",
    lang_select_category: "Select category",
    lang_set_three_shopman: "Set 3D shop assistant",
    lang_please_open_eshopopee: "Please open E-Shopopee",
    lang_inv_code_placeholder_hint: "(Optional)",
    lang_inv_code_not_exist: "Invite code does not exist",
    lang_shop_exp: "3D shop expiry",
    lang_no_shop_alert: "No shop opened",
    lang_inv_code: "Invite code",
    lang_inv_gift_notice: "Hint: Extend basic shop for 30 days if at least one user registers using your invite code each month",
    lang_shop_item: "Shop products",
    lang_three_shop_renew: "3D shop renewal",
    lang_transport_manage: "Transport management",
    lang_main_language_not_empty: "Main language name cannot be empty",
    lang_sub_language_not_empty: "Sub-language name cannot be empty",
    lang_transport_cost_not_empty: "Shipping cost cannot be empty",
    lang_transport_cost_not_correct: "Incorrect shipping cost",
    lang_my_invcode: "My invite code",
    lang_three_shop_share_link: "3D shop share link",
    lang_invcode_reg_link: "Invite code registration link",
    lang_inv_record: "Invite record",
    lang_buy_card: "Buy card",
    lang_pls_upload_header_img: "Please upload profile picture",
    lang_paid_card_not_found: "Card not found, contact website admin",
    lang_company_card_not_found: "Company card not found, contact company admin",
    lang_shop_control_room: "Shop control room",
    lang_detail_text_1: "Details",
    lang_staff_num: "Staff number",
    lang_three_shop_exp: "3D shop validity",
    lang_card_front: "Card front",
    lang_card_opposite: "Card back",
    lang_select_exp_item_pls: "Please select validity period",
    lang_pay_confirm_text: "Confirm payment?",
    lang_customer_bill: "Company bill",
    lang_repeat_bo_confim: "Unpaid order exists, pay or delete it",
    lang_renew_manage: "Renewal management",
    lang_company_admin_limit: "Company admin limit",
    lang_admin_limit_warning: "Admin limit reached, buy more admin slots",
    lang_pls_open_three_shop: "Please open 3D shop first",
    lang_area_code: "Area code",
    lang_pls_input_ac: "Please enter area code",
    lang_auto_replay_offline_switch_text: "Enable offline reminder?",
    lang_online_time: "Online time",
    lang_remind_notice_1: "Seller may be offline, inquire if no response for a long time, seller will reply when online.",
    lang_ask_enterprise: "Inquire seller",
    lang_contact_email: "Contact email",
    lang_contact_tel: "Contact phone",
    lang_contact_tel_des: "Contact phone (optional)",
    lang_ask_content: "Inquiry content",
    lang_ask_content_too_long: "Inquiry content too long",
    lang_pls_input_email: "Please enter contact email",
    lang_user_not_input: "User did not enter",
    lang_close_offline_notice_pls: "Please close offline reminder first",
    lang_open_auto_notice_pls: "Please enable auto-reply first",
    lang_activate_time: "Activation time",
    lang_format_warning_spc: "Cannot contain special characters",
    lang_unvisivle_account: "Deleted account",
    lang_staff_num_unlimit: "No limit for regular staff",
    lang_company_detail_1: "Company overview",
    lang_3d_price_1: "3D shop price",
    lang_inv_user_login: "Inviter's email",
    lang_inv_user_name: "Inviter's name",
    lang_exit_preview: "Exit preview",
    lang_new_join_card_1: "Newest member card",
    lang_company_news_info: "Company news",
    lang_new_join_cnews_1: "Newest company overview and news",
    lang_me: "Me",
    lang_manger_system: "Management system",
    lang_buy_nfc_card: "Buy NFC card",
    lang_custom_order: "Customer order",
    lang_country: "Country or region",
    lang_select_country_pls: "Please select country or region",
    lang_add_t_method_1: "Add shipping method",
    lang_select_market_pls: "Please select market",
    lang_company_curr: "Currency unit",
    lang_product_name_en_2: "Product name (English)",
    lang_product_description_en_2: "Product description (English)",
    lang_product_cost_2: "Product sales price",
    lang_upload_product: "Upload product",
    lang_select_product_pls: "Please select product category",
    lang_upload_product_img_pls: "Please upload product image",
    lang_upload_img: "Upload image",
    lang_del_confirm: "Confirm to delete this item?",
    lang_cn_name: "Chinese name",
    lang_en_name: "English name",
    lang_shop_position: "Shop location",
    lang_my_inv: "My invitation",
    select_market_pls: "Please select market",
    lang_login_not_empty: "Username cannot be empty",
    lang_password_not_empty: "Password cannot be empty",
    lang_report_data_1: "Report data",
    lang_open_sound: "Enable sound",
    lang_mute: "Mute",
    lang_clear_cache: "Clear cache",
    lang_search_text: "Search",
    lang_my_phone: "My phone",
    lang_Operator_3d: "Operator",
    lang_doornum_option_text: "Door number (optional)",
    lang_area_num: "Area number",
    lang_select_area_door_num_pls: "Please select area and door number",
    lang_passerby_sentence_1_1: "Three people standing by the helipad's flashing light can take you where you want to go.",
    lang_passerby_sentence_1_2: "Find them if you want to quickly go to a specific store in an area.",
    lang_passerby_sentence_2_1: "Heard that if you open a shop now, you get 30 days free and a corresponding website system.",
    lang_passerby_sentence_2_2: "If you're interested, open a shop now.",
    lang_passerby_sentence_3_1: "If you want to ask the store some questions, find the store's assistant in front.",
    lang_passerby_sentence_3_2: "They can answer your questions and exchange cards with you.",
    lang_passerby_sentence_4_1: "There's an ad board in front of each store, you can see the latest products through it.",
    lang_passerby_sentence_5_1: "If you want to buy a store's product, you can order directly while talking to the assistant.",
    lang_next_district: "Next area",
    lang_check: "Check",
    lang_view_confirm_msg: "There's a new report, view it?",
    lang_application_to: "Apply to join",

    lang_contact_shopopee_pls: "Please contact Shopopee",
    lang_Conversation: "Conversation",
    lang_passerby: "Passerby",
    lang_Under_renovation: "Under renovation",
    lang_shop_website_1: "Shop website",
    lang_receive_card_pls: "Please accept my card",
    lang_go_next_confirm: "Go to the next area?",
    lang_go_eshopopee_shop_confrim_1: "Enter",
    lang_go_eshopopee_shop_confrim_2: "Shop? (Will redirect to e-shopopee website)",
    lang_welcome_3d_msg_1: "Welcome, please follow me to",
    lang_welcome_3d_msg_2: "Welcome to 3D shopopee mall.",
    lang_welcome_3d_msg_3: "Hong Kong's first 3D exhibition center, promoting your products or services in new ways to more people.",
    lang_welcome_3d_msg_4: "Apply for free, get your first 3D shop plate now!",
    lang_welcome_3d_msg_5: "Do you need me to guide you to other areas?",
    lang_not_chat_self: "Cannot chat with yourself",
    lang_not_open_shop_again: "You have already opened a shop, please do not apply again",
    lang_return_shopopee_confirm: "Confirm to return to Shopopee?",
    lang_go_eshopopee_confirm_1: "Will redirect to e-shopopee website, confirm?",
    lang_viewers: "Viewers",
    lang_chat_text: "Chat",
    lang_my_account: "My account",
    lang_open_shop_3d: "Open shop",
    lang_edit_staff: "Edit staff",
    lang_join_hall_manager: "Exhibit management",
    lang_temporary_no_data: "No record",
    lang_hall_num: "Hall number",
    lang_hall_visible_time: "Hall validity time",
    lang_hall_appy_time: "Hall registration time",
    lang_hall_des: "Hall description",
    lang_img_position_display: "Corresponding image display",
    lang_shop_name_pad_1: "Shop sign",
    lang_adv_img: "Ad image",
    lang_join_hall_cost: "Exhibition cost",
    lang_join_hall: "Exhibit",
    lang_entry_time: "Registration time",
    lang_open_time: "Opening time",
    lang_applied: "Applied",
    lang_upload_adv_img_notice: "Note: If no image is uploaded, the ad board will not display; image size limit 300KB",
    lang_aspect_ratio: "Aspect ratio",
    lang_upload_shopname_pad_img_pls: "Please upload shop sign image",
    lang_applied_warning: "Applied, do not apply again",
    lang_apply_success: "Application successful",
    lang_edit: "Edit",
    lang_file_over_limit: "File size exceeds limit",
    lang_pay_1: "Pay",
    lang_hall_already_finish: "Exhibition has ended",
    lang_join_hall_time_confirm_1: "Shop validity insufficient, renew?",
    lang_change_lang_confirm: "Changing language requires reload to take effect, reload now?",
    lang_sound: "Sound",
    lang_toggle_views: "Toggle views",
    lang_guide_text: "Guide",
    lang_lang: "Language",
    lang_first_person: "First person",
    lang_third_person: "Third person",
    lang_sex: "Sex",
    lang_male: "Male",
    lang_female: "Female",
    lang_shopman_sex: "Shop assistant sex",
    lang_no_setting: "No setting",
    lang_select_goto_hall: "Please select hall to go to",
    lang_go_hall_confirm: "Go to the hall?",
    lang_return_3dShop_confirm_1: "Return to 3D commercial city?",
    lang_shop_item_1: "Shop item",
    lang_elevator: "Elevator",
    lang_select_floor_num_pls: "Please select floor",
    lang_floor_num: "Floor number",
    lang_item_1: "Item",
    lang_booth: "Booth",
    lang_go_shop_view: "Go to shop view",
    lang_go_booth: "Go to booth",
    lang_booth_position: "Booth position",
    lang_business_directory: "Business directory",
    lang_goto_floor: "Go to floor",
    lang_pls_select_region: "Please select region",
    lang_not_open: "Not open",
    lang_img_size_1: "Image size",
    lang_return_3d_city: "Return to 3D city",
    lang_language_toggle: "Language toggle",
    lang_slow: "Slow",
    lang_normal: "Normal",
    lang_fast: "Fast",
    lang_fast_2: "Very fast",
    lang_move_speed: "Move speed",
    lang_region_toggle: "Region toggle",
    lang_change_region_confirm: "Switching region requires reload to take effect, reload now?",
    lang_download_company_pdf_confirm: "Download company brochure?",
    lang_chat_group_files: "Group files",
    lang_enter_text: "Enter",
    lang_group_member: "Group members",
    lang_none_group_file: "No files",
    lang_go_eshopopee_confirm_2: "Will redirect to E-Shopopee, confirm?",
    lang_user_email_has_reg: "User email already registered",
    lang_add_staff_success_alert_text: "Added successfully, registration email sent! Please check, it may go to spam!",
    lang_invite_staff_success_alert_text: "Invite successful, invite email sent",
    lang_invite_staff_fail_alert_text_1: "Invite failed, user already an employee",
    lang_add_contact_method_1: "Add contact method",
    lang_edit_contact_method_1: "Edit contact method",
    lang_custom_text: "Custom",
    lang_submit_success: "Submitted successfully",
    lang_receive_email_address: "Receive shared email",
    lang_share_Preset_content_1: "Hello, this is",
    lang_share_Preset_content_2: "e-card on Shopopee, nice to meet you.",
    lang_repeat_include_2: "Card already included, do not include again",
    lang_3d_business_city: "3D commercial city",
    lang_create_shop_success_alert: "Shop created successfully, add products?",
    lang_hk_ex_center_1: "Hong Kong exhibition center",
    lang_more_img: "More images",
    lang_Honors_and_Certificates: "Honors and certificates",
    lang_img_text_1: "Image",
    lang_edit_detail_text: "Edit introduction",
    lang_edit_detail_text_to_photo: "Edit introduction (image to text)",
    lang_temporary_no_join_ex_data: "No exhibition records",
    lang_exhibited_products: "Exhibited products",
    lang_free_to_select: "Optional",
    lang_already_select: "Selected",
    lang_already_sold: "Sold",
    lang_already_reserve: "Reserved",
    lang_confirm_select: "Confirm selection",
    lang_select_hall_position_pls: "Please select booth",
    lang_confirm_del_record15_text_1: "Confirm to delete reservation record?",
    lang_input_companyname_pls: "Please enter company name",
    lang_input_companyaddress_pls: "Please enter company address",
    lang_input_companytel_pls: "Please enter company phone",
    lang_input_companyemail_pls: "Please enter company email",
    lang_about_jump_to: "Will redirect to",
    lang_card_forward: "Card forward",
    lang_card_editor: "Card editor",
    lang_go_hongkong: "Go to Hong Kong",
    lang_unit_code: "Unit code",
    lang_unit_name_zh: "Product unit name (Chinese)",
    lang_unit_name_en: "Product unit name (English)",
    lang_add_product_unit: "Add product unit",
    lang_pls_input_unit_zh_name: "Please enter product unit name in Chinese",
    lang_pls_input_unit_en_name: "Please enter product unit name in English",
    lang_unit_repeat_warning: "Product unit already exists",

    lang_add_success: "Added successfully",
    lang_operation_method: "Operation method",
    lang_normal_text: "Normal",
    lang_free_perspective: "Free view",
    lang_region_setting: "Region settings",
    lang_add_region_setting: "Add region settings",
    lang_save_region_setting: "Save region settings",
    lang_min_buy_qty: "Min purchase qty",
    lang_wholesale_setting: "Wholesale settings",
    lang_get_quo_price: "Get quote",
    lang_join_hall_material: "Exhibition products",
    lang_buy_detail: "Purchase details",
    lang_unit_price: "Unit price",
    lang_buy_num: "Quantity",
    lang_total_price_num: "Total price",
    lang_search_order_ref: "Search order no.",
    lang_bill_record_detail: "Billing details",
    lang_select_join_hall_material: "Select exhibition products",
    lang_not_quote_self: "Cannot quote yourself",
    lang_all_region: "All regions",
    lang_district: "District",
    lang_quotation: "Quotation",
    lang_tel_text: "Phone",
    lang_email_text: "Email",
    lang_order_number_text: "Order no.",
    lang_order_date_text: "Order date",
    lang_sale_man: "Salesperson",
    lang_payment_terms: "Payment terms",
    lang_product_des: "Product description",
    lang_qty: "Quantity",
    lang_curr: "Currency",
    lang_total: "Total",
    lang_confirm_text: "Confirm",
    lang_Company_seal_signature: "Company stamp and signature",
    lang_delivery_remark: "Delivery notes",
    lang_add_delivery_deliveryname: "Add delivery notes",
    lang_chinese_remark: "Chinese description",
    lang_english_remark: "English description",
    lang_no_support_your_region: "Product not supported in your region",
    lang_wholesale: "Wholesale price",
    lang_min_buy_num: "Min purchase qty",
    lang_get_quote: "Get quote",
    lang_check_quotion: "Confirm quotation",
    lang_select_transport_pls: "Select transport method",
    lang_submit_quotation_confirm_1: "Submitted. View quotation?",
    lang_chinese_text: "Chinese",
    lang_my_quotation: "My quotation",
    lang_select_region_confirm: "Proceed?",
    lang_zoom: "Zoom",
    lang_myagent: "My agent",
    lang_agent_1: "Agent",
    lang_supplier: "Supplier",
    lang_myagent_1: "My agent",
    lang_agent_companycode: "Agent company code",
    lang_agent_companyname: "Agent company name",
    lang_agent_host_address: "Agent domain",
    lang_agent_host_company_code: "Company code on agent domain",
    lang_go_agent_host_warning: "Redirect to agent domain. Proceed?",
    lang_agent_company: "Agent company",
    lang_input_agent_host_pls: "Enter agent domain",
    lang_input_agent_host_company_code_pls: "Enter company code on agent domain",
    lang_supplier_companycode: "Supplier company code",
    lang_supplier_name: "Supplier name",
    lang_supplier_login: "Supplier login",
    lang_mall_companycode: "Mall company code",
    lang_select_supplier_company: "Select supplier",
    lang_sponsor: "Organizer",
    lang_renew: "Renew",
    lang_product_manager: "Product management",
    lang_receive_method_1: "Payment method",
    lang_hall_manager_1: "Exhibition management",
    lang_return_control_room: "Back to control room",
    lang_add_receive_manager: "Add payment method",
    lang_Organize_exhibitions: "Organize exhibition",
    lang_Join_exhibitions: "Join exhibition",
    lang_join_exhibitions_manager: "Exhibition management",
    lang_exhibition_name: "Exhibition name",
    lang_exhibition_name_en: "Exhibition English name",
    lang_apply_time: "Apply date",
    lang_exhibition_type: "Exhibition type",
    lang_exhibition_stage: "Exhibition scene",
    lang_exhibition_des: "Exhibition description",
    lang_exhibition_des_en: "Exhibition English description",
    lang_exhibition_cover: "Exhibition cover",
    lang_exhibition_cover_en: "Exhibition English cover",
    lang_exhibition_banner_img: "Exhibition banner",
    lang_exhibition_banner_img_en: "Exhibition English banner",
    lang_invite_person_label: "Invite contacts to 3DShopopee",
    lang_website_manage: "Website management",
    lang_hall_position_manager: "Booth management",
    lang_hide_item_confirm: "Hide this product?",
    lang_show_item_confirm: "Show this product?",
    lang_department_info: "Department info",
    lang_3d_shop_des: "View and manage your shop",
    lang_3d_exhibition: "3D exhibition",
    lang_3d_exhibition_des: "View and manage your exhibition",
    lang_my_website: "My website",
    lang_my_website_des: "View and manage your website",
    lang_my_card_des: "View and manage your card",
    lang_manage_sys_des: "View and manage backend center",
    lang_quotation_des: "View and manage your quotations",
    lang_website_setting: "Website settings",
    lang_open_shop_des: "Open 3D shop",
    lang_open_shop_success: "Shop opened. Please reload page",
    lang_company_manage_sys: "Company management system",
    lang_name_eng_1: "English name",
    lang_address_eng_1: "English address",
    lang_world_hall: "International hall",
    lang_local_hall: "Local hall",
    lang_market: "Mall",
    lang_hall_1: "Hall",
    lang_open_hall_alert: "Max hall limit reached",
    lang_toggle: "Switch",
    lang_toggle_hall_confirm_1: "Switch to hall?",
    lang_toggle_shop_confirm_1: "Switch to mall?",
    lang_customer_manage: "Customer management",
    lang_order_manage: "Order management",
    lang_order_i_received: "Orders received",
    lang_order_i_placed: "Orders placed",
    lang_order_i_received_des: "View orders I received",
    lang_order_i_placed_des: "View orders I placed",
    lang_enter_shopmall: "Enter mall",
    lang_join_hall_company: "Exhibitor company",
    lang_mall_manage: "Mall management",
    lang_mall_manage_des: "View and manage mall",
    lang_island_manage: "Island management",
    lang_island_manage_des: "View and manage island",
    lang_created_mall: "My mall",
    lang_join_mall: "Join mall",
    lang_mall_name: "Mall name",
    lang_mall_name_en: "Mall English name",
    lang_mall_des: "Mall description",
    lang_mall_des_en: "Mall English description",
    lang_mall_cover: "Mall cover",
    lang_mall_cover_en: "Mall English cover",
    lang_mall_banner_img: "Mall banner",
    lang_mall_banner_img_en: "Mall English banner",
    lang_mall_limit_alert: "Hall limit reached",
    lang_target_company: "Target company",
    lang_doornum_text: "Door number",
    lang_approved_confirm: "Approve request?",
    lang_position_occupied: "Position occupied",
    lang_shop_settled_in: "Settled shops",
    lang_shop_products: "Shop products",
    lang_des: "Description",
    lang_invite_url: "Invite link",
    lang_island_name: "Island name",
    lang_island_name_en: "Island English name",
    lang_island_domain: "Island domain",
    lang_island_name_input_alert: "Enter island name",
    lang_shop_manager_1: "Shop management",
    lang_island_merchants: "Island shops",
    lang_disable: "Disable",
    lang_enable: "Enable",
    lang_go_other_island: "Go to another island",
    lang_toggle_island: "Switch island",
    lang_activate_acc_pls: "Activate account",
    lang_welcome_img: "Welcome image",
    lang_welcome_img_en: "Welcome image (EN)",

    lang_description_img: "Introduction Image",
    lang_description_img_en: "Introduction Image (English)",
    lang_island: "Island",
    lang_auth: "Authorization",
    lang_not_open_shop: "Shop Not Opened",
    lang_companycode: "Company Code",
    lang_position_move: "Move Position",
    lang_disable_shop: "Disable Shop",
    lang_edit_auth: "Edit Authorization",
    lang_staff_manage: "Staff Management",
    lang_enable_shop: "Enable Shop",
    lang_shop_disable: "Shop Disabled",
    lang_logoff_company_confirm_3: "You are about to cancel the company. This action cannot be undone. Are you sure?",
    lang_join_mall_1: "Join",
    lang_join_already: "Joined",
    lang_submit_record_already: "Application Submitted",
    lang_reg_date: "Registration Date",
    lang_login_date: "Login Date",
    lang_type: "Type",
    lang_island_url: "Island URL",
    lang_account_stoped: "Account Suspended",
    lang_go_mall_confirm_2: "to the mall?",
    lang_shop_url: "Shop URL",
    lang_copy_shop_url_alert: "Shop URL Copied",
    lang_mall_signboard: "Mall Signboard",
    lang_mall_signboard_en: "Mall Signboard (English)",
    lang_Half_body_photo: "Half-Body Photo",
    lang_file_size_limit: "No More Than",
    lang_share: "Share",
    lang_go_shop_confirm_3: "to browse the shop?",
    lang_island_share_content: "Interactive 3D shop in a virtual space. Shop from home and enjoy a new shopping experience!",
    lang_hall_share_content: "Save my 3DShopopee card and stay connected!",
    lang_mall_share_content: "Innovative exhibition experience with 3D Shopopee booth immersion!",
    lang_agent_share_content: "Welcome to apply as our product agent!",
    lang_scale: "Size",
    lang_ratio: "Ratio",
    lang_such_as: "Such as",
    lang_suggested: "Suggested",
    lang_Aspect_ratio: "Aspect Ratio",
    lang_Suggested_Resolution: "Suggested Resolution",
    lang_hall_2: "Exhibition Hall",
    lang_communicate: "Communicate",
    lang_auth_manage: "Authorization Management",
    lang_start_date: "Start Date",
    lang_end_date: "End Date",
    lang_admin_num_limit: "Admin Limit",
    lang_create_hall_num_limit: "Exhibition Limit",
    lang_mall_num_limit: "Mall Limit",
    lang_island_num_limit: "Island Limit",
    lang_sub_company_limit: "Sub-Company Limit",
    lang_ride: "Ride",
    lang_stop_car: "Stop Car",
    lang_get_down: "Get Down",
    lang_forward_text: "Forward",
    lang_mall_model: "Mall Model",
    lang_server_center: "Service Center",
    lang_speak_center: "Speaker Stand",
    lang_t_stage: "T-Stage",
    lang_stage: "Stage Image",
    lang_taxi: "Taxi",
    lang_my_hall_des: "View and Manage Your Exhibition",
    lang_return_search: "Return to Search",
    lang_download_doc: "Download Document",
    lang_hongkong_map: "Hong Kong Map",
    lang_my_ads: "My Ads",
    lang_title_en: "English Title",
    lang_youtube_video_url: "YouTube Video URL",
    lang_red_url: "Red Link",
    lang_facebook_url: "Facebook Link",
    lang_titok_url: "TikTok Link",
    lang_my_video: "My Videos",
    lang_3d_shop_share: "3D Shop Share",
    lang_open_shop_Transaction_fees_des: "Note: 10% transaction fee per transaction.",
    lang_use_paypal_pay: "Pay via PayPal",
    lang_select_chat_method: "Choose Chat Method",
    lang_store_status: "Shop Status",
    lang_select_status_method: "Choose Shop Website",
    land_store_not_opent: "Shop is not open yet. Please visit later.",
    land_disable_auxiliary_collection: "Unified Collection",
    land_hall_model: "Model",
    land_hall_exhibition_model: "International Exhibition Model",
    land_hall_exhibition_model2: "Local Exhibition Model",
    land_hall_exhibition_model3: "Mall Model",
    lang_apply_exhibition: "Apply for Exhibition",
    lang_successfully_completed: "Successfully Completed",
    lang_start_promoting_images: "Start Promotion Images",
    lang_end_promoting_images: "End Promotion Images",
    lang_end_promoting_links: "End Promotion Links",
    lang_product_cost_is_not_null: "Product Price Cannot Be Empty",
    lang_Please_include_the_order_number_in_the_transfer_instructions: "Please include the order number in transfer notes.",
    lang_Total_order_quantity: "Total Order Quantity",
    lang_Total_amount: "Total Amount",
    lang_Confirm_the_total_amount: "Confirm Total Amount",
    lang_Total_views: "Total Views",
    lang_The_event_has_ended: "Event has ended, you cannot make purchases!",
    lang_sell:"Sell",
    lang_discount_coupons:"Discount Coupons",
    lang_coupons_amount:"Coupons amount",
    lang_coupons_discount:"coupons discount",
    lang_Advanced_Setting: "Advanced Setting",
    lang_Nofilling_Norestrictions:"0 or no filling indicates unlimited quantity",
    lang_Quantity_used:"Quantity Used:",
    lang_Promo_Number:"Promo Number",
    lang_Full_amount:"Full amount",
    lang_Reduce_amount:"Reduce amount"
}

export default en